import { SetStateAction } from 'react';
import { createShallowStore, createStoreWithPersist } from '@frontend/store';
import { DEFAULT_FILTERS } from './constants';
import type { FilterState } from './types';

type ScheduleActivityFiltersStore = {
  filtersMap: Record<string, FilterState>;
  setFilters: (locationId: string, update: SetStateAction<FilterState>) => void;
  resetFilters: (locationId: string) => void;
};

const useScheduleActivityFiltersStore = createStoreWithPersist<ScheduleActivityFiltersStore>(
  (set) => ({
    filtersMap: {},
    setFilters: (locationId, update) => {
      set(
        (state) => {
          const previousFilters = state.filtersMap[locationId] ?? DEFAULT_FILTERS;
          const nextFilters = typeof update === 'function' ? update(previousFilters) : update;
          return {
            filtersMap: {
              ...state.filtersMap,
              [locationId]: nextFilters,
            },
          };
        },
        false,
        'SET_SCHEDULE_ACTIVITY_FILTERS'
      );
    },
    resetFilters: (locationId) => {
      set(
        (state) => ({
          filtersMap: {
            ...state.filtersMap,
            [locationId]: DEFAULT_FILTERS,
          },
        }),
        false,
        'RESET_SCHEDULE_ACTIVITY_FILTERS'
      );
    },
  }),
  {
    name: 'schedule-activity-filters-store',
  },
  {
    name: 'ScheduleActivityFiltersStore',
    trace: true,
  }
);

export const useScheduleActivityFiltersShallowStore = createShallowStore(useScheduleActivityFiltersStore);
